export default {"src":"/_next/static/media/beef.e92b5aba.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};